import {
  FETCHING_COLLECTIONS_REQUEST, FETCHING_COLLECTIONS_SUCCEEDED, FETCHING_COLLECTIONS_FAILED,
  FETCHING_COLLECTION_REQUEST, FETCHING_COLLECTION_SUCCEEDED, FETCHING_COLLECTION_FAILED,
  FETCHING_COLLECTION_SECTION_REQUEST, FETCHING_COLLECTION_SECTION_SUCCEEDED, FETCHING_COLLECTION_SECTION_FAILED,
  GENERATE_COLLECTION_LINK_REQUEST, GENERATE_COLLECTION_LINK_SUCCEDDED, GENERATE_COLLECTION_LINK_FAILED,
  SEARCHING_COLLECTIONS_REQUEST, SEARCHING_COLLECTIONS_SUCCEEDED, SEARCHING_COLLECTIONS_FAILED,
  INVALIDATE_COLLECTIONS_SEARCH
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import buildUrl from 'build-url';
import { call, put, takeEvery } from 'redux-saga/effects';

const apiUrl = process.env.REACT_APP_API_URL;
const COLLECTION_BASE_URL = `${apiUrl}/api/2.0/collections`;
const COLLECTION_SECTION_BASE_URL = `${apiUrl}/api/2.0/collections/sections`;
const COLLECTION_BASE_URL_V21 = `${apiUrl}/api/2.1/collections`;
const SEARCH_BASE_URL = `${apiUrl}/api/2.0/search`;

/*
* Fetch collections
*/
export const fetchCollections = createAction(FETCHING_COLLECTIONS_REQUEST);
const fetchingCollectionsSucceeded = createAction(FETCHING_COLLECTIONS_SUCCEEDED);
const fetchingCollectionsFailed = createAction(FETCHING_COLLECTIONS_FAILED);

function* fetchCollectionsSaga(action) {
  const page = action.payload;

  let config = {
    params: { page: page, limit: 30 }
  }

 
  const fetchCollectionsAPI = () => {
    return axios.get(COLLECTION_BASE_URL_V21, config).then(response => response.data);
  }

  try {
    const response = yield call(fetchCollectionsAPI);
    yield put(fetchingCollectionsSucceeded(response));
  } catch (error) {
    yield put(fetchingCollectionsFailed(error));
  }
}

/*
* Fetch collection
*/
export const fetchCollection = createAction(FETCHING_COLLECTION_REQUEST, (id, callback) => {
  return {id, callback };
});
const fetchingCollectionSucceeded = createAction(FETCHING_COLLECTION_SUCCEEDED);
const fetchingCollectionFailed = createAction(FETCHING_COLLECTION_FAILED);

function* fetchCollectionSaga(action) {
  const {id, callback }= action.payload;

  let url = buildUrl(COLLECTION_BASE_URL, {
    path: `${id}`
  });
 
  const fetchCollectionAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchCollectionAPI);
    yield put(fetchingCollectionSucceeded({id,response}));
    if(callback){
      callback(response);
    }
  } catch (error) {
    yield put(fetchingCollectionFailed({id,error}));
  }
}

/*
* Fetch collection section
*/
export const fetchCollectionSection = createAction(FETCHING_COLLECTION_SECTION_REQUEST, (collectionId, sectionId) => {
  return {collectionId, sectionId};
});
const fetchingCollectionSectionSucceeded = createAction(FETCHING_COLLECTION_SECTION_SUCCEEDED);
const fetchingCollectionSectionFailed = createAction(FETCHING_COLLECTION_SECTION_FAILED);

function* fetchCollectionSectionSaga(action) {
  const collectionId = action.payload.collectionId;
  const sectionId = action.payload.sectionId;

  let url = buildUrl(COLLECTION_SECTION_BASE_URL, {
    path: `${sectionId}`
  });

  const fetchCollectionSectionAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchCollectionSectionAPI);
    yield put(fetchingCollectionSectionSucceeded({collectionId, sectionId, response}));
  } catch (error) {
    yield put(fetchingCollectionSectionFailed({collectionId, sectionId, error}));
  }
}

/**
* Generate Collection Anonymous link
*/
export const generateCollectionLink = createAction(GENERATE_COLLECTION_LINK_REQUEST, (collection, request, callback) => {
  return {collection, request, callback};
});
const generatingCollectionLinkSuccedded = createAction(GENERATE_COLLECTION_LINK_SUCCEDDED);
const generatingCollectionLinkFailed = createAction(GENERATE_COLLECTION_LINK_FAILED);

function* generateCollectionLinkSaga(action) {
  const { collection, request, callback } = action.payload;
  const collectionId = collection.id;

  let url = buildUrl(COLLECTION_BASE_URL, {
    path: `${collectionId}/link`
  });
 
  const createGenerateCollectionLinkAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(createGenerateCollectionLinkAPI);
    yield put(generatingCollectionLinkSuccedded({collectionId,response}));
    if(callback){
      callback(response);
    }
  } catch (error) {
    yield put(generatingCollectionLinkFailed({collectionId, error}));
  }
}

/*
* Search collections
*/
export const searchCollections = createAction(SEARCHING_COLLECTIONS_REQUEST, (query, filter, page, limit, highlight) => {
  return { query, filter, page, limit, highlight };
});
const searchingCollectionsSucceeded = createAction(SEARCHING_COLLECTIONS_SUCCEEDED, (query, response) => ({ query, response }));
const searchingCollectionsFailed = createAction(SEARCHING_COLLECTIONS_FAILED, (query, error) => ({ query, error }));

export const invalidateCollectionsSearch = createAction(INVALIDATE_COLLECTIONS_SEARCH);

function* searchCollectionsSaga(action) {
  const { query, filter, page, limit, highlight } = action.payload;

  let url = buildUrl(SEARCH_BASE_URL, {
    path: `collections/${page}`
  });


  var additionalFilters = filter || {};
  let param = {
    ...additionalFilters,
    query: query,
    limit: limit,
    highlight: highlight,
  };

  const searchCollectionsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
      params: param,
    }).then(response => response.data);
  }

  try {
    const response = yield call(searchCollectionsAPI);
    yield put(searchingCollectionsSucceeded(query, response));
  } catch (error) {
    yield put(searchingCollectionsFailed(query, error));
  }
}

export default function* collectionsSaga() {
  yield takeEvery(FETCHING_COLLECTIONS_REQUEST, fetchCollectionsSaga);
  yield takeEvery(FETCHING_COLLECTION_REQUEST, fetchCollectionSaga);
  yield takeEvery(FETCHING_COLLECTION_SECTION_REQUEST, fetchCollectionSectionSaga)
  yield takeEvery(GENERATE_COLLECTION_LINK_REQUEST, generateCollectionLinkSaga);
  yield takeEvery(SEARCHING_COLLECTIONS_REQUEST, searchCollectionsSaga)
};
